<script setup lang="ts">
import { CircleAlert, CircleCheck, X } from 'lucide-vue-next';
import { useToasts } from '../stores/toast';

const toasts = useToasts();
</script>

<template>
  <div class="toasts" aria-live="polite">
    <TransitionGroup name="toast">
      <div
        v-for="t in toasts.items"
        :key="t.id"
        class="toast"
        :class="`is-${t.tone}`"
        role="status"
      >
        <CircleCheck v-if="t.tone === 'ok'" class="toast-icon" />
        <CircleAlert v-else class="toast-icon" />
        <span>{{ t.text }}</span>
        <button
          class="toast-close"
          aria-label="Kapat"
          v-tip="'Kapat'"
          @click="toasts.dismiss(t.id)"
        >
          <X />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toasts {
  position: fixed;
  right: 1.25rem;
  bottom: 1.25rem;
  z-index: 70;
  display: grid;
  gap: 0.5rem;
  width: min(24rem, calc(100vw - 2rem));
}
.toast {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  padding: 0.75rem 0.75rem 0.75rem 0.9rem;
  border-radius: var(--radius-m);
  background: var(--ink);
  color: var(--surface);
  font-size: var(--t-s);
  box-shadow: var(--shadow-pop);
}
.toast-icon {
  flex: none;
  width: 1.05rem;
  height: 1.05rem;
  margin-top: 0.1rem;
  color: var(--gold-soft);
}
.toast.is-danger .toast-icon {
  color: #f6a39a;
}
.toast-close {
  margin-left: auto;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  opacity: 0.6;
  cursor: pointer;
}
.toast-close svg {
  width: 1rem;
  height: 1rem;
}
.toast-enter-active,
.toast-leave-active {
  transition:
    opacity 0.18s,
    transform 0.18s;
}
.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateY(0.5rem);
}
@media (max-width: 760px) {
  /* Above the tab bar, across the screen. */
  .toasts {
    right: 0.75rem;
    bottom: calc(4.5rem + env(safe-area-inset-bottom));
    left: 0.75rem;
    width: auto;
  }
}
</style>
